// extracted by mini-css-extract-plugin
export default {"wrapper":"LevelCard_wrapper__jYCx3","titles":"LevelCard_titles__s+bsV"};